import { defineComponent } from 'vue';
import { hostPath } from '@/public/utils/basePath';
import { goToStudy, jumpModuleApp, appPort } from '@/widget';
export default defineComponent({
    props: {
        item: {
            default() {
                return {};
            },
            type: Object
        },
        size: {
            default: 'big',
            type: String
        },
        small: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        toDetail(item) {
            if (appPort()) {
                if (item.moduleType == 'open') {
                    goToStudy('album', item.albumId);
                }
                else {
                    jumpModuleApp({
                        typeId: 'h5',
                        url: `${hostPath}/learn/courseguide/album/${item.albumId}`
                    });
                }
            }
            else {
                if (item.moduleType == 'open') {
                    goToStudy('album', item.albumId);
                    // location.assign(`${hostPath}/open/detail?id=${item.albumId}`)
                }
                else {
                    this.$router.push({
                        path: `/courseguide/album/${item.albumId}`
                    });
                }
            }
        }
    }
});
